/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Stephan JAMBOU
 * @date        22/04/2022 10:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Navbar from '@scripts/components/navbar'
import apiFetch from '@wordpress/api-fetch'
import DropdownAction from './actions/DropdownAction'
import ParallaxComponent from './components/Parallax'

document.addEventListener('DOMContentLoaded', () => {
    new DropdownAction()
    new Navbar()
    new ParallaxComponent()

    if ($('.home').length > 0) {
        import('@scripts/components/home' /* webpackChunkName: "scripts/home" */).then(
            ({ default: Home }) => {
                new Home()
            },
        )
    }
    if ($('.fullscreen').length > 0) {
        import('@scripts/services/layout' /* webpackChunkName: "scripts/layout" */).then(
            ({ default: Layout }) => {
                new Layout()
            },
        )
    }

    $(window).on('scroll', () => {
        const sidebarTop = $('.sidebar').offset().top
        const sidebarHeight = $('.sidebar').height()
        const bannerHeight = $('.header__banner').height()
        const sidebarBottom = sidebarTop + sidebarHeight
        if (!$('header').hasClass('header--without-banner')) {
            if (sidebarBottom > bannerHeight) {
                if (!$('.sidebar').hasClass('sidebar--dark')) {
                    $('.sidebar').addClass('sidebar--dark')
                }
            } else {
                $('.sidebar').removeClass('sidebar--dark')
            }
        }
    })

    /* Strate SEO --------------------------- */
    $(document).on('click', '.seo__right__more__link', function (e) {
        $(this).toggleClass('open')
        $('.seo__right__content_more').slideToggle()
    })

    /* Strate instagram --------------------- */
    if ($('[data-id="social-wall"]').length > 0 && !$('[data-id="social-wall"]').is(':hidden')) {
        apiFetch({
            path: IRISCollectionCustomer.irisSsoInstagramPath,
            method: 'POST',
            data: { limit: 7 },
        })
            .then((result) => {
                $('[data-id="social-wall"]').html(result.render)
                import(
                    '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                ).then(({ default: hc_lazyload }) => {
                    hc_lazyload()
                })
            })
            .catch(() => {
                $('[data-id="social-wall"]').html('')
            })
    }

    /* Strate animation --------------------- */
    $(window).bind('scroll', () => {
        // If user show all strates
        const offset = 250

        if (window.matchMedia('(min-width: 1000px)').matches) {
            if ($('.strate--animated').length !== $('.strate--animated.is-active').length) {
                const currentTop = $(window).scrollTop()
                const currentBottom = $(window).scrollTop() + $(window).height()
                $('.strate--animated').each(function (index) {
                    const elemTop = $(this).offset().top
                    const elemBottom = elemTop + $(this).height()
                    if (currentBottom - offset >= elemTop) {
                        $(this).addClass('is-active')
                    }
                })
            }
        }
    })

    /* Back to top --------------------- */
    $(window).on('load scroll', function () {
        const scroll_top = $(this).scrollTop()

        if (scroll_top > 70) {
            $('.footer__content__backtotop').fadeIn('is-visible')
        } else {
            $('.footer__content__backtotop').fadeOut('is-visible')
        }
    })
})
